import React from 'react';
import { useTheme } from 'styled-components';

import Icon from '../icon';

import { BackgroundImage, Container, StyledButton, Title } from './styles';

const JoinUsSection = ({ buttonText, handleDiscordClick, title }) => {
  const theme = useTheme();

  return (
    <Container>
      <BackgroundImage>
        <Title>{title}</Title>
        <StyledButton
          onClick={handleDiscordClick}
          startIcon={
            <Icon color={theme.palette.neutral.white} name="discord" />
          }
          variant="contained"
        >
          {buttonText}
        </StyledButton>
      </BackgroundImage>
    </Container>
  );
};

export default JoinUsSection;
